import { API_URL } from "../config/connect";

const getAnalytics = async () => {
    const endpoint = `${API_URL}/api/v1/analytics/summary`;
    const googleIdToken = localStorage.getItem("google_id_token");
    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${googleIdToken}`,
                "Content-Type": "application/json",
            }
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('There was a problem fetching the analytics:', error);
        throw error;
    }
};

export default getAnalytics;